import { supabase } from '../clients/supabaseClient';

export type DriverStatsSummary = {
    driver_id: string;
    driver_name: string;
    total: number;
    completed: number;
    failed: number;
    on_route: number;
    awaiting_acceptance: number;
    cancelled: number;
    avg_response_time_seconds: number | null;
    avg_driving_time_seconds: number | null;
    avg_full_lifecycle_seconds: number | null;
};

export type DriverDeliveryDetail = {
    delivery_id: string;
    order_id: string;
    order_reference: string;
    driver_id: string;
    driver_name: string;
    status: string;
    created_at: string;
    assigned_at: string | null;
    delivered_at: string | null;
    last_updated: string | null;
    failure_reason: string | null;
    response_time_seconds: number | null;
    driving_time_seconds: number | null;
    full_lifecycle_seconds: number | null;
};

export async function fetchAdminDriverStats(
    startDate: string,
    endDate: string
): Promise<DriverStatsSummary[]> {
    const { data, error } = await supabase.functions.invoke('get-admin-driver-stats', {
        body: { start_date: startDate, end_date: endDate },
    });
    if (error) throw error;
    if (data?.error) throw new Error(data.error);
    return (data?.drivers ?? []) as DriverStatsSummary[];
}

export async function fetchAdminDriverDetail(
    driverId: string,
    startDate: string,
    endDate: string
): Promise<DriverDeliveryDetail[]> {
    const { data, error } = await supabase.functions.invoke('get-admin-driver-detail', {
        body: { driver_id: driverId, start_date: startDate, end_date: endDate },
    });
    if (error) throw error;
    if (data?.error) throw new Error(data.error);
    return (data?.deliveries ?? []) as DriverDeliveryDetail[];
}
